const WORDS = ["ONE SIGNAL", "ZERO NOISE", "SHIP FASTER", "FULL CLARITY", "IN CONTROL"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((word, i) => (
      <span key={word} className="flex items-center">
        <span
          className={`font-display px-8 text-6xl font-black tracking-tight md:text-8xl ${
            i % 2 === 0 ? "text-outline" : "text-outline-green"
          }`}
        >
          {word}
        </span>
        <span className="h-2 w-2 rounded-full bg-[#00FF66]/40" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section
      className="relative overflow-hidden border-y border-white/5 py-16"
      aria-hidden="true"
      data-testid="marquee-section"
    >
      <div className="animate-marquee flex w-max opacity-60">
        <Row />
        <Row />
      </div>
    </section>
  );
}
